'use strict';

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');

const getHelpCenterLinks=require('./getHelpCenterLinks');
const HelpDeskPhoneNumber='877.791.0989';let

HelpCenterController=class HelpCenterController extends BaseController{
constructor(uncaughtErrorHandler,breadcrumbsService,userService){
super(uncaughtErrorHandler);

breadcrumbsService.startTrail('Help Center');

const fatigueMeterType=_.get(userService,'currentUser.fatigueMeterType',FatigueMeterType.Trucking);

this._links=getHelpCenterLinks(fatigueMeterType);
}

get helpDeskPhoneNumber(){
return HelpDeskPhoneNumber;
}

get links(){
return this._links;
}};


module.exports=HelpCenterController;
//# sourceMappingURL=helpCenterController.js.map
